import React from "react";
import ReactDOM from "react-dom/client";
// import { Dapp } from "./components/Dapp"; // Commented out or remove Dapp
import LpPerformanceTracker from "./components/LpPerformanceTracker"; // Import the LP Tracker

// We import bootstrap here, but you can remove if you want
import "bootstrap/dist/css/bootstrap.css";

// This is the entry point of your application.
// It will now render the LpPerformanceTracker component.

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    {/* <Dapp /> */}
    <LpPerformanceTracker /> {/* Render the LP Tracker component */}
  </React.StrictMode>
);
